import styled from 'styled-components';

export const AttributionModelStyled = styled.div`
  display: flex;
  flex-direction: row;
  gap: 16px;
  width: 100%;
  margin-top: 16px;
  .attributionModel {
    &Selector,
    &Range,
    &RangeLoader {
      flex: 1;
      min-width: 0;
    }
    &Range {
      position: relative;
      &Label {
        color: ${props => props.theme.uiColors.selectorLabel};
      }
      &Input:not(input) {
        margin-bottom: 0;
        margin-top: 8px;
        justify-content: flex-start;
        gap: 16px;
      }
      &Input input {
        height: 40px;
        font-size: ${props => props.theme.fontSizeS};
      }
    }
  }
`;
